import {
  drugtransaction_retailorder_list,
  drugtransaction_retailorder_read,
  drugtransaction_retailorder_message_create,
  drugtransaction_retailorder_payment_partial_update,
  drugtransaction_retailorder_request_invoice_create,
  drugtransaction_importation_cart_read,
  drugtransaction_importation_cart_partial_update,
  drugtransaction_importation_cart_documentation_document_create,
  drugtransaction_importation_cart_documentation_document_delete,
  drugtransaction_importation_cart_importation_create,
  drugtransaction_importation_cart_importation_update,
  drugtransaction_importation_cart_item_list_drug_create,
  drugtransaction_importation_cart_item_list_drug_partial_update,
  drugtransaction_importation_cart_item_list_drug_delete,
  drugtransaction_payment_intention_create,
  drugtransaction_payment_intention_list,
  drugtransaction_payment_intention_read,
} from "@/lib/api-client.js";
import { getAxiosConfig as axconf } from "@/lib/api-config.js";

import Vue from "vue";

export default {
  namespaced: true,
  state: {
    refund_config_fiels: [],
    importation_uploaded_files: [],
    importation_cart: undefined,
    importation_cart_item_list_drugs: [],
    payment_intentions: undefined,
  },
  actions: {
    GET_RETAIL_ORDER_LIST: (undefined, payload) => {
      const offset = payload.per_page * (payload.current_page - 1);
      return new Promise((resolve, reject) => {
        drugtransaction_retailorder_list({
          $config: axconf(),
          role: "patient",
          roleUuid: "1",
          offset: offset,
          limit: payload.per_page,
          search: payload.search || undefined,
        }).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_IMPORTATION_CART: ({ commit }) => {
      return new Promise((resolve, reject) => {
        drugtransaction_importation_cart_read({
          $config: axconf(),
          role: "patient",
          roleUuid: "1",
        }).then(
          response => {
            commit("MUTATE_IMPORTATION_CART", response.data);
            resolve(response);
          },
          err => {
            commit("MUTATE_IMPORTATION_CART", undefined);
            reject(err);
          }
        );
      });
    },
    REQUEST_UPDATE_IMPORTATION_CART: (undefined, payload) => {
      return new Promise((resolve, reject) => {
        drugtransaction_importation_cart_partial_update({
          $config: axconf(),
          role: "patient",
          roleUuid: "1",
          data: payload.data,
        }).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_RETAIL_ORDER: (undefined, payload) => {
      return new Promise((resolve, reject) => {
        drugtransaction_retailorder_read({
          $config: axconf(),
          role: "patient",
          roleUuid: "1",
          orderUuid: payload.order_uuid,
        }).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    SEND_RETAIL_ORDER_MESSAGE: (undefined, payload) => {
      return new Promise((resolve, reject) => {
        drugtransaction_retailorder_message_create({
          data: payload.data,
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
          orderUuid: payload.order_uuid,
        }).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_CREATE_IMPORTATION_CART_DRUG: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        drugtransaction_importation_cart_item_list_drug_create({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
          data: payload.data,
        }).then(
          response => {
            commit("MUTATE_REFRESH_FROM_DB_IMPORTATION_CART_ITEM_LIST_DRUG", {
              current_item: payload.current_item,
              newdata: response.data,
            });
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_UPDATE_IMPORTATION_CART_DRUG: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        drugtransaction_importation_cart_item_list_drug_partial_update({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
          drugsnapshotUuid: payload.drugsnapshot_uuid,
          data: payload.data,
        }).then(
          response => {
            commit("MUTATE_REFRESH_FROM_DB_IMPORTATION_CART_ITEM_LIST_DRUG", {
              current_item: payload.current_item,
              newdata: response.data,
            });
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_UPDATE_IMPORTATION_CART_IMPORTATION: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        drugtransaction_importation_cart_importation_update({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
          importationUuid: payload.importation_uuid,
          data: payload.data,
        }).then(
          response => {
            commit(
              "MUTATE_REFRESH_FROM_DB_IMPORTATION_CART_IMPORTATION",
              response.data
            );
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_CREATE_IMPORTATION_CART_IMPORTATION: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        drugtransaction_importation_cart_importation_create({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
          data: payload.data,
        }).then(
          response => {
            commit(
              "MUTATE_REFRESH_FROM_DB_IMPORTATION_CART_IMPORTATION",
              response.data
            );
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_DELETE_IMPORTATION_CART_DRUG: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        if (payload.drugsnapshot_uuid) {
          drugtransaction_importation_cart_item_list_drug_delete({
            $config: axconf(),
            role: "vooyguest",
            roleUuid: "1",
            drugsnapshotUuid: payload.drugsnapshot_uuid,
          }).then(
            response => {
              commit(
                "MUTATE_DELETE_IMPORTATION_CART_ITEM_LIST_DRUG",
                payload.current_item
              );
              resolve(response);
            },
            err => {
              reject(err);
            }
          );
        } else {
          commit(
            "MUTATE_DELETE_IMPORTATION_CART_ITEM_LIST_DRUG",
            payload.current_item
          );
          resolve("OK");
        }
      });
    },
    SEND_IMPORTATION_CART_DOCUMENT: (undefined, payload) => {
      let extraconf = {};
      if (payload.onUploadProgress) {
        extraconf["onUploadProgress"] = payload.onUploadProgress;
      }
      return new Promise((resolve, reject) => {
        drugtransaction_importation_cart_documentation_document_create({
          $config: axconf(extraconf),
          role: "vooyguest",
          roleUuid: "1",
          data: payload.data,
        }).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    DELETE_IMPORTATION_CART_DOCUMENT: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        drugtransaction_importation_cart_documentation_document_delete({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
          documentUuid: payload.document_uuid,
        }).then(
          response => {
            commit(
              "MUTATE_DELETE_IMPORTATION_UPLOADED_FILES",
              payload.document_uuid
            );
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    SET_BANK_DEPOSIT_REFERENCE: (undefined, payload) => {
      return new Promise((resolve, reject) => {
        drugtransaction_retailorder_payment_partial_update({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
          orderUuid: payload.order_uuid,
          transactionUuid: payload.payment_transaction_uuid,
          data: {
            service_bank_deposit_reference: payload.payment_reference,
            service_bank_deposit_SEC: payload.SEC,
            service_bank_deposit_sheet: payload.sheet,
            service_bank_deposit_date: payload.date,
            service_bank_deposit_remitter: payload.remitter,
            service_bank_deposit_amount: payload.amount,
          },
        }).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    ADD_DRAFT_IMPORTATION_CART_ITEM_LIST_DRUG: ({ commit }, drug) => {
      return new Promise(resolve => {
        commit("MUTATE_ADD_DRAFT_IMPORTATION_CART_ITEM_LIST_DRUG", drug);
        resolve("OK");
      });
    },
    READ_PAYMENT_INTENTION: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        drugtransaction_payment_intention_read({
          role: "vooyguest",
          roleUuid: "1",
          paymentIntentionUuid: payload.payment_intention_uuid,
          $config: axconf(),
        }).then(
          response => {
            if (response.data.done == true) {
              commit("MUTATE_DELETE_PAYMENT_INTENTION", response.data);
            }
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    CREATE_PAYMENT_INTENTION: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        drugtransaction_payment_intention_create({
          data: payload.data,
          role: "vooyguest",
          roleUuid: "1",
          $config: axconf(),
        }).then(
          response => {
            commit("MUTATE_PUSH_PAYMENT_INTENTION", response.data);
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    LIST_PAYMENT_INTENTIONS: ({ commit }) => {
      return new Promise((resolve, reject) => {
        drugtransaction_payment_intention_list({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
        }).then(
          response => {
            commit("MUTATE_PAYMENT_INTENTIONS", response.data.results);
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    RETAILORDER_REQUEST_INVOICE: (undefined, payload) => {
      return new Promise((resolve, reject) => {
        drugtransaction_retailorder_request_invoice_create({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
          orderUuid: payload.order_uuid,
          data: payload.data,
        }).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
  },
  mutations: {
    // Añade un nuevo medicamento al item list del carrito internacional
    // se marca como "sucio" -> necesita ser enviado al backend
    MUTATE_ADD_DRAFT_IMPORTATION_CART_ITEM_LIST_DRUG: (state, drug) => {
      state.importation_cart_item_list_drugs.push(
        Object.assign({ isdirty: true }, drug)
      );
    },
    MUTATE_DELETE_IMPORTATION_CART_ITEM_LIST_DRUG: (state, drug) => {
      let index = state.importation_cart_item_list_drugs.indexOf(drug);
      state.importation_cart_item_list_drugs.splice(index, 1);
    },
    // Modifica la cantidad de un drug en el item list del carrito internacional
    // se marca como "sucio" -> necesita ser enviado al backend
    MUTATE_QUANTITY_DRAFT_IMPORTATION_CART_ITEM_LIST_DRUG: (state, payload) => {
      state.importation_cart_item_list_drugs.forEach((element, index) => {
        if (element == payload.item) {
          let curr = state.importation_cart_item_list_drugs[index];
          curr.isdirty = true;
          curr.quantity = payload.quantity;
          state.importation_cart_item_list_drugs.splice(index, 1, curr);
        }
      });
    },
    MUTATE_REFRESH_FROM_DB_IMPORTATION_CART_ITEM_LIST_DRUG: (
      state,
      payload
    ) => {
      state.importation_cart_item_list_drugs.forEach((element, index) => {
        if (element == payload.current_item) {
          // state.importation_cart_item_list_drugs[index].isdirty = false;
          state.importation_cart_item_list_drugs.splice(
            index,
            1,
            Object.assign({}, payload.newdata)
          );
        }
      });
    },
    MUTATE_REFRESH_FROM_DB_IMPORTATION_CART_IMPORTATION: (store, data) => {
      store.importation_cart.importation = Object.assign({}, data);
    },
    MUTATE_IMPORTATION_UPLOADED_FILES: (state, payload) => {
      var files = state.importation_uploaded_files;
      payload.forEach(element => {
        files.push(Object.assign({}, element));
      });
      Vue.set(state, "importation_uploaded_files", files);
    },
    MUTATE_DELETE_IMPORTATION_UPLOADED_FILES: (state, document_uuid) => {
      var files = [];
      var current_files = state.importation_uploaded_files;
      current_files.forEach(element => {
        if (element.uuid != document_uuid) {
          files.push(Object.assign({}, element));
        }
      });
      Vue.set(state, "importation_uploaded_files", files);
    },
    MUTATE_CLEAR_IMPORTATION_UPLOADED_FILES: state => {
      state.importation_uploaded_files = [];
    },
    MUTATE_IMPORTATION_CART: (state, payload) => {
      if (!payload) {
        Vue.set(state, "importation_cart", undefined);
        return;
      }

      state.importation_cart = Object.assign({}, payload);
      state.importation_cart_item_list_drugs = payload.item_list.drugs;
    },
    MUTATE_PAYMENT_INTENTIONS: (state, intentions) => {
      state.payment_intentions = intentions;
    },
    MUTATE_PUSH_PAYMENT_INTENTION: (state, intention) => {
      state.payment_intentions.push(intention);
    },
    MUTATE_DELETE_PAYMENT_INTENTION: (state, intention) => {
      let found_index = null;
      if (!state.payment_intentions) {
        return;
      }

      state.payment_intentions.forEach((element, index) => {
        if (element.uuid == intention.uuid) {
          found_index = index;
        }
      });
      if (found_index) {
        state.payment_intentions.splice(found_index, 1);
      }
    },
  },
  getters: {
    getImportationCartIsDirtyDrugs: state => {
      var drugs =
        state.importation_cart_item_list_drugs.filter(drug => {
          return drug.isdirty === true;
        }) || [];
      return drugs;
    },
  },
};
